import MainPresetsIcon from '@material-ui/icons/GroupWork'
import AdCategoriesIcon from '@material-ui/icons/Loyalty'
import BuildIcon from '@material-ui/icons/Build'
export default [
    {
      "path": "/slicer",
      "label": "Event Select",
      "icon": AdCategoriesIcon
    },
    {
      "path": "/preset",
      "label": "Ad Sets and Norms",
      "icon": MainPresetsIcon
    },
    {
      "path": "/builder",
      "label": "Builder",
      "icon": BuildIcon
    },
  ]
  


// WEBPACK FOOTER //
// ./src/app/configuration/CategoryTentpoleEvents/config/sidebar.js